import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { ExerciseStatus, ExerciseStatusMap } from "API/exercise";

interface StatusProps {
    status: ExerciseStatus;
}

export default function Status({ status }: StatusProps) {
    return (
        <span className={classNames(style.root, style[`state${status}`])}>
            {ExerciseStatusMap[status]}
        </span>
    );
}
